import Children from '../../../layouts/Children';

const routes = [
  {
    path: 'companies',
    component: Children,

    children: [
      {
        path: '',
        name: 'companies',
        component: () =>
          import('@/modules/companies/pages/CompaniesPage')
      },

      {
        path: 'create',
        name: 'companies.create',
        component: () => import('@/modules/companies/pages/CompanyCreatePage')
      },

      {
        path: ':id',
        name: 'companies.show',
        component: () => import('@/modules/companies/pages/CompanyShowPage'),
        props: route => ({
          id: Number(route.params.id)
        })
      }
    ]
  }
];

export default routes;
